// ** Initial State
const initialState = {
  events: [],
  selectedEvent: {},
  selectedCalendars: ['Events', 'Holidays', 'Leaves', 'Tasks']
}

const calendarReducer = (state = initialState, action) => {
  switch (action.type) {
    case 'FETCH_EVENTS':
      return { ...state, events: action.events }
    case 'ADD_EVENT':
      return { ...state }
    case 'REMOVE_EVENT':
      return { ...state }
    case 'UPDATE_EVENT':
      return { ...state }
    case 'UPDATE_FILTERS': {
      let selectedCalendars = [...state.selectedCalendars, action.filter]
      if (state.selectedCalendars.includes(action.filter)) {
        selectedCalendars = state.selectedCalendars.filter(i => i !== action.filter)
      }
      return {
        ...state,
        selectedCalendars,
        events: selectedCalendars.length === 0 ? [] : state.events
      }
    }
    case 'UPDATE_ALL_FILTERS':
      return { ...state, selectedCalendars: action.value === true ? ['Events', 'Holidays', 'Leaves', 'Tasks'] : [] }
    case 'SELECT_EVENT':
      return { ...state, selectedEvent: action.event }
    default:
      return state
  }
}

export default calendarReducer
